export default "__VITE_ASSET__Ce3nHwfo__"